import * as Sentry from "@sentry/browser";

export function sentryFeedbackHandler() {

  const feedback = Sentry.feedbackIntegration({autoInject: false});
  feedback.openDialog()
}
